//imports
import {
    DEVICE_DETAIL_GET_DATA_REQUEST,
    DEVICE_DETAIL_GET_DATA_REQUEST_RESULT,
    DEVICE_DETAIL_SHOW,
    DEVICE_DETAIL_HIDE,
} from 'Redux/actionTypes';

export const deviceDetailShow = (data) => ({
    type: DEVICE_DETAIL_SHOW,
    payload: data
  });

export const deviceDetailGetDataRequest = (id) => ({
    type: DEVICE_DETAIL_GET_DATA_REQUEST,
    payload: {id},
});

export const deviceDetailGetDataRequestResult = (result) => ({
    type: DEVICE_DETAIL_GET_DATA_REQUEST_RESULT,
    payload: result
});

export const deviceDetailHide = () => ({
    type: DEVICE_DETAIL_HIDE,
    payload: {}
  });